function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPay1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 127,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 93 63.5)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -0.4 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(31,114,205)",
      fillRule: "nonzero",
      opacity: 1
    },
    x: -92.604,
    y: -63.5,
    rx: 15.875,
    ry: 15.875,
    width: 185.208,
    height: 127
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -0.35 0.68)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "evenodd",
      opacity: 1
    },
    transform: " translate(-92.65, -64.18)",
    d: "M 33.2035 44.9792 L 15.875 83.3266 L 36.6196 83.3266 L 39.1913 77.2124 L 45.0697 77.2124 L 47.6415 83.3266 L 70.4755 83.3266 L 70.4755 78.6601 L 72.5101 83.3266 L 84.3216 83.3266 L 86.3563 78.5614 L 86.3563 83.3266 L 133.845 83.3266 L 139.619 77.3712 L 145.026 83.3266 L 169.417 83.3759 L 152.034 64.26 L 169.417 44.9792 L 145.404 44.9792 L 139.783 50.8246 L 134.547 44.9792 L 82.8854 44.9792 L 78.4493 54.877 L 73.909 44.9792 L 53.2077 44.9792 L 53.2077 49.487 L 50.9048 44.9792 L 33.2035 44.9792 Z M 104.118 50.4246 L 131.388 50.4246 L 139.729 59.434 L 148.338 50.4246 L 156.679 50.4246 L 144.006 64.2545 L 156.679 77.9251 L 147.96 77.9251 L 139.619 68.811 L 130.966 77.9251 L 104.118 77.9251 L 104.118 50.4246 Z M 110.852 61.1454 L 110.852 56.1222 L 110.852 56.1174 L 127.868 56.1174 L 135.293 64.1507 L 127.539 72.228 L 110.852 72.228 L 110.852 66.7441 L 125.729 66.7441 L 125.729 61.1454 L 110.852 61.1454 Z M 37.2174 50.4246 L 47.3293 50.4246 L 58.8233 76.4281 L 58.8233 50.4246 L 69.9005 50.4246 L 78.7782 69.069 L 86.9601 50.4246 L 97.982 50.4246 L 97.982 77.9413 L 91.2754 77.9413 L 91.2207 56.3794 L 81.4432 77.9413 L 75.4439 77.9413 L 65.6117 56.3794 L 65.6117 77.9413 L 51.8148 77.9413 L 49.1992 71.7724 L 35.0679 71.7724 L 32.4577 77.9359 L 25.0655 77.9359 L 37.2174 50.4246 Z M 37.4809 66.0693 L 42.1366 55.08 L 46.7869 66.0693 L 37.4809 66.0693 Z",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPay1);
export default __webpack_public_path__ + "static/media/Pay1.27183d1ffbdb8424a9867e78ccad62e6.svg";
export { ForwardRef as ReactComponent };